import PropTypes from 'prop-types'
import React from 'react'

import { Article, FaqBg, FaqLabel, TextStyled } from './styles'

/**
 * Component of FAQ Gut Tab. Used within FaqGut component
 * @return {Component} Component — FaqGutTab
 */
export const FaqGutTab = ({
  activeIndex,
  title,
  tabIndex,
  isActive,
  labelClassName,
  onClick,
  theme,
}) => {
  const handleClick = React.useCallback(() => {
    if (onClick) {
      onClick(tabIndex)
    }
  }, [onClick, tabIndex])
  return (
    <Article
      color={theme}
      isActive={isActive}
      tabIndex={tabIndex}
      isNextToActive={activeIndex + 1 === tabIndex}
      onClick={handleClick}
    >
      <FaqBg />
      <FaqLabel>
        <TextStyled
          className={labelClassName}
          dangerouslySetInnerHTML={{ __html: title }}
        />
      </FaqLabel>
    </Article>
  )
}

FaqGutTab.propTypes = {
  /** Title of Item */
  title: PropTypes.string.isRequired,

  /** Index of active tab */
  activeIndex: PropTypes.number,

  /** Flag to control tab state */
  isActive: PropTypes.bool,

  /** Label class name */
  labelClassName: PropTypes.string,

  /** Item index */
  tabIndex: PropTypes.number,

  /** Theme of the tab (white or gray) */
  theme: PropTypes.oneOf(['white', 'gray']),

  /** Click callback */
  onClick: PropTypes.func,
}

FaqGutTab.defaultProps = {
  activeIndex: 0,
  isActive: false,
  labelClassName: '',
  theme: 'white',
}

export default React.memo(FaqGutTab)
